import React from 'react';

// import '@style/components/moduleIcon.scss';
import '../styles/components/moduleIcon.scss';

export const ICON_TYPES = {
  TouchScreen: 'touchscreen', // n
  Bubble: 'bubble-plot',
  Building: 'building',
  Engagement: 'engagement', //n
  Governance: 'governance',
  Survey: 'survey',
  Labs: 'labs', // n
  SpeedoMeter: 'speedometer', // n
  Setting: 'setting',
  Change: 'change',
  Partership: 'partership',
  Question: 'help-question',
  Home: 'home',
  Bulb: 'bulb',
  BarChart: 'bar-chart',
  ListView: 'list-view',
  // BarChart: 'bar-chart',
  BridgeChart: 'bridgechart',
  GrowRevenue: 'grow-revenue',
  Global: 'globe',
  SparkLine: 'spark-line',
  PieChart: 'pie-chart',
  PowerBI: 'powerbi',
  GanttChart: 'gantt_chart',
  DialHigh: 'dial_high',
  Savings: 'savings1',
  SpiderChart: 'spider-chart',
  Dashboard: 'dashboard',
  Analysis: 'analysis',
  Kpi: 'kpi',
};

const CustomizedIcons = [
  ICON_TYPES.TouchScreen,
  ICON_TYPES.Engagement,
  ICON_TYPES.Labs,
  ICON_TYPES.SpeedoMeter,
  ICON_TYPES.BridgeChart,
  ICON_TYPES.PowerBI,
  ICON_TYPES.GanttChart,
  ICON_TYPES.DialHigh,
  ICON_TYPES.Savings,
  ICON_TYPES.Dashboard,
  ICON_TYPES.Analysis,
  ICON_TYPES.Kpi,
];

const ModuleIcon = ({ type, isActive = false }) => {
  let className;

  if (Object.values(ICON_TYPES).includes(type)) {
    className = `icon-${type}-${isActive ? 'fill' : 'outline'}`;
  } else {
    className = isActive ? type?.replace('outline', 'fill') || '' : type;
  }

  return (
    <span
      className={`${className} appkiticon ${
        CustomizedIcons.includes(type) ? 'customized-icon' : ''
      }`}
    />
  );
};

export default ModuleIcon;
